<div class="col-xs-12">
  <qrcode [qrdata]="id" [width]="256" [errorCorrectionLevel]="'M'" [elementType]="'svg'"></qrcode>
</div>
